import React, {useEffect, useRef} from 'react';
import BottomSheet from 'src/components/bottom-sheet';
import {useDispatch, useSelector} from 'react-redux';
import {selectrootsheettype} from '../../../../selectors/SheetSelector';
import {isWeb, windowWidth} from '../../../../constants';
import {Image, View} from 'react-native';
import {showSheet} from '../../../../actions/SheetActions';
import {StyleSheet} from 'react-native';
import {CustomText} from '../../../../components';
import {useTranslation} from 'react-i18next';
import PrimaryButton from '../../../../components/primary-button/PrimaryButton.component';
import SVG from '../../../../imports/svg';

let animationFrameId;

const TripMessageSheet = () => {
  const dispatch = useDispatch();
  const {sheetId, sheetProps} = useSelector(state =>
    selectrootsheettype(state),
  );
  const onClose = sheetProps?.onClose
  const {t} = useTranslation();
  const bottomSheetRef = useRef<any>(null);
  
  const closeBottomSheet = () => {
    if (isWeb) {
      bottomSheetRef?.current?.snapTo(() => 0);
    } else {
      bottomSheetRef.current?.close();
      setTimeout(() => {
        onClose && onClose()
        dispatch(
          showSheet({
            sheetId: '',
          }),
        );
      }, 500);
    }
  };

  const renderTitle=()=>{
    switch(sheetProps.type){
      case 'vehicle_has_discount' : return t('you_dont_have_discount_code_in_this_trip') ;
      case 'existing_reservation' : return t('you_have_an_existing_reservation');
      case 'existing_trip' : return t('you_have_an_existing_trip');
      case 'vehicle_not_found' : return t('vehicle_has_reserved_with_another_person');
      case 'vpn' : return t('please_turn_off_vpn');
      case 'lock_stuck' : return t('vehicle_is_locked_now');
      case 'reservation_has_ended' : return t('your_reservation_has_ended');
      case 'not_in_your_city' : return t('we_will_be_coming_to_your_city_soon');
      case 'admin_ended_trip' : return t('admin_end_trip');
    } 
  }

  const renderDesc=()=>{
    switch(sheetProps.type){
    case 'vpn' : return t('for_betther_user_experience_please_turn_off_vpn') ;
    case 'existing_reservation' : return t('for_reserving_new_vehicle_please_cancle_previous') ;
    case 'existing_trip' : return t('for_reserving_new_vehicle_please_cancle_previous') ;
    case 'vehicle_not_found' : return t('please_reserve_another_vehicle');
    case 'lock_stuck' : return `${t('lock_tab_is_stuck_in_the_wheel')}\n${t('move_the_wheel_and_pull_the_lock')}`;
    case 'vehicle_has_discount' : return t('you_cant_use_discount_code_with_this_vehicle')
    case 'reservation_has_ended' : return '' ;
    case 'not_in_your_city' : return '';
    case 'admin_ended_trip' : return t('your_trip_has_been_ended_by_admin') ;
    }
  }

  const renderSVG=()=>{
    switch(sheetProps.type){
      case 'vehicle_has_discount' : return <SVG name={'zeeroVehicle'}  width={164} height={164}/>
      case 'vehicle_not_found' : return <SVG width={196} height={196} name={'zeeroVehicleUser'}/>
      case 'reservation_has_ended' : return <SVG width={196} height={196} name={'zeeroVehicleReserve'}/>
      case 'lock_stuck' : return <Image style={styles.lockImage} source={require('src/assets/images/lock.png')}/>
      case 'vpn' : return <SVG name={'security'} width={196} height={196}/>
      case 'existing_reservation' : return <SVG name={'zeeroVehicle'}  width={196} height={196}/>
      case 'existing_trip' : return <SVG name={'zeeroVehicle'}  width={196} height={196}/>
      case 'not_in_your_city' : return <SVG name={'zeeroVehicleUser'}  width={196} height={196}/>
      default : return <></>
    }
  }

  const switchHeight=()=>{
    switch(sheetProps.type){
       case 'vehicle_has_discount' : return 395 ;
       case 'vehicle_not_found' : return 406 ;
       case 'reservation_has_ended' : return 406;
       case 'lock_stuck' : return 435;
       case 'vpn' : return 427;
       case 'existing_reservation' : return 427
       case 'existing_trip' : return 427
       case 'not_in_your_city' : return 427
       default : return 0
    }
  }

  return (
    <BottomSheet
      ref={bottomSheetRef}
      snapPoints={isWeb ? ({minHeight}: any) => [1, minHeight] : [switchHeight()]}
      onSpringEnd={
        isWeb
          ? () => {
              if (bottomSheetRef?.current?.height < 2) {
                onClose && onClose()
                dispatch(
                  showSheet({
                    sheetId: '',
                  }),
                );
              }
            }
          : undefined
      }
      defaultSnap={isWeb ? switchHeight() : undefined}
      blocking={isWeb ? true : undefined}
      open={true}
      isScrollView={isWeb ? undefined : false}
      handleIndicatorStyle={
        !isWeb ? {backgroundColor: 'transparent'} : undefined
      }
      onClose={closeBottomSheet}>



      <View style={[
        styles.container ,
         { height : switchHeight()}]}>
        {renderSVG()}
        <CustomText txtAlign='center' mt={12} size={18} font={'700'}>
          {renderTitle()}
        </CustomText>
        <CustomText txtAlign='center' mt={12} size={15} font={'500'} color={'#5A5A5A'}>
          {renderDesc()}
        </CustomText>
        <PrimaryButton onPress={closeBottomSheet} containerStyle={styles.button} title={t('i_realized')}>
        </PrimaryButton>
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  container: {
    width : '100%' , 
    alignItems : 'center' , 
    paddingHorizontal  : 16 
  },
  lockImage : {
    width : 196 , 
    height :196 , 
    resizeMode : 'contain' , 
    marginTop : 18 , 
  },
  button : {
    alignSelf : 'center' , 
    position : 'absolute' , 
    bottom : isWeb ? 24 : 44 ,
    width : windowWidth - 32  , 
  }
});

export default TripMessageSheet;
